<template>
  <b-nav class="nav-toggled">
    <!-- <img class="Item" src="@/assets/PentagroIcon2.png" alt="Ícone Pentagro" /> -->

    <b-nav-item-dropdown no-caret :text="$t('analytics')" class="toggled" left>
      <b-dropdown-item
        class="drop-item"
        :to="`/Analytics/managementgreatness`"
        v-if="user.Permissions.gestaograndezas.allowed && user.Permissions.gestaograndezas.permission"
      >
        <img
          class="dropItem"
          src="@/assets/bottles.png"
          :alt="$t('gestao-de-grandezas')"
        />
        {{ user.Permissions.gestaograndezas.permission }}
      </b-dropdown-item>
      <b-dropdown-item
        class="drop-item"
        v-b-modal.newAnalysis
        v-if="user.Permissions.lancamentoanalise.allowed && user.Permissions.lancamentoanalise.permission"
      >
        <img
          class="dropItem"
          src="@/assets/dashboard.png"
          :alt="$t('lancar-de-analises')"
        />
        {{ user.Permissions.lancamentoanalise.permission }}
      </b-dropdown-item>
      <b-dropdown-item
        class="drop-item"
        :to="`/Analytics`"
        v-if="user.Permissions.gestaodeanalise.allowed && user.Permissions.gestaodeanalise.permission"
      >
        <img
          class="dropItem"
          src="@/assets/dashboard.png"
          :alt="$t('gestao-de-analises')"
        />
        {{ user.Permissions.gestaodeanalise.permission }}
      </b-dropdown-item>
      <!--<b-dropdown-item
        class="drop-item"
        :to="`/dashboard/${user.Permissions.dashboard02.parameter}`"
        v-if="user.Permissions.dashboard02.allowed"
      >
        <img
          class="dropItem"
          src="@/assets/dashboard.png"
          alt="Cadastro de Processos"
        />
        {{ user.Permissions.dashboard02.permission }}
      </b-dropdown-item>

      <b-dropdown-item
        class="drop-item"
        :to="`/dashboard/${user.Permissions.dashboard03.parameter}`"
        v-if="user.Permissions.dashboard03.allowed"
      >
        <img
          class="dropItem"
          src="@/assets/dashboard.png"
          alt="Cadastro de Equipamentos"
        />
        {{ user.Permissions.dashboard03.permission }}
      </b-dropdown-item> -->
    </b-nav-item-dropdown>
    <b-modal
      id="newAnalysis"
      size="xl"
      hide-footer
      :title="$t('lancar-analise')"
      :no-close-on-backdrop="true"
    >
      <newAnalysis></newAnalysis>
    </b-modal>
  </b-nav>
</template>

    <script>
import { mapState } from "vuex";
import newAnalysis from "../analytics/newAnalysis.vue";

export default {
  name: "AnalyticsDropdown",
  components: { newAnalysis },
  created() {},
  computed: mapState(["user"]),
};
</script>

<style scoped>
.txt {
  color: white;
  padding: 10px 20px;
}

img.Item {
  max-height: 37px;
  max-width: 37px;
  border-radius: 5px;
  margin: auto;
}

img.dropItem {
  max-height: 25px;
  max-width: 25px;
  border-radius: 5px;
  margin-right: 10px;
}

.ilink {
  margin-right: 10px;
}
</style>

    <style>
.dropdown-menu {
  height: auto;
  max-height: 350px;
  overflow-y: auto;
}
</style>
